module.exports = __webpack_public_path__ + "static/covid-c909a9c8346153c5112a92d33604da51.jpg";